var $ = require('jquery');
var _ = require('underscore');
var tectoastr = require('tectoastr');
var PusherClass = require('pusher-js');

if (typeof pusherOptions != 'undefined') {
    options = pusherOptions.clarify();
    var pusher = new PusherClass(options.appKey, options.options);

    var tokenExists = token => typeof token != 'undefined' && $('.' + token).length;

    var refreshIfExists = function (token) {
        if (tokenExists(token)) {
            var url = window.location.pathname + window.location.search;
            $.pjax({url: url, container: '#pjaxContainer', method: 'GET'});
        }
    };

    var refreshIfUrl = function (url) {
        if (window.location.pathname === url) {
            var currentUrl = window.location.pathname + window.location.search;
            $.pjax({url: currentUrl, container: '#pjaxContainer', method: 'GET'});
        }
    };

    _.each(options.channels, function (channelName) {
        var channel = pusher.subscribe(channelName);

        channel.bind('message.simple', function(data) {
            tectoastr.notify(data.type, data.message);

            // Full pjax refresh
            refreshIfExists(data.refreshIfExists);

            // Trigger 'file.transcoding' event
            if (_.has(data, 'data') && _.has(data.data, 'transcodedFiles')) {
                $(document).trigger('file.transcoding', data);
            }
        });

        channel.bind('file.processed', (data) => $(document).trigger('file.processed', data));

        channel.bind('roles.revoked', function(data) {
            if (data.message) {
                tectoastr.notify('info', data.message);
            }
            refreshIfUrl('/user');
        });

        channel.bind('leaderboard.sync', function(data) {
            if (data.message) {
                tectoastr.notify('info', data.message);
            }

            if (data.status == 'finished') {
                refreshIfExists(data.refreshToken);
            } else if (tokenExists(data.refreshToken)) {
                var recalculating = data.type == 'recalculate' || ! $('.leaderboard-recalculate').hasClass('hidden');
                $('.leaderboard-recalculate').toggleClass('hidden', ! recalculating);
                $('.leaderboard-sync').toggleClass('hidden', recalculating);
            }
        });

        channel.bind('plagiarism.resources_found', function (data) {
            let actions = $('#full-scan-actions');

            if (data.error) {
              actions.html(data.error);
            } else {
              actions.html(data.actions);
            }
        });

      channel.bind('field_values.recalculation_completed', function (data) {
        if (data.message) {
          tectoastr.notify('info', data.message);
        }

        $(`.hide-on-field-${data.slug}`).addClass('hidden');
        $(`.show-on-field-${data.slug}`).removeClass('hidden');
        $(`.enable-on-field-${data.slug}`).prop( "disabled", false );
        $(`.disable-on-field-${data.slug}`).prop( "disabled", true );
      });

      channel.bind('duplicate_entries.scan_completed', function (data) {
          refreshIfExists(data.refreshIfExists);
      });
    });
}
